// extracted by mini-css-extract-plugin
module.exports = {"section":"EditCompany_section__3O5i2","title-card":"EditCompany_title-card__313ly","line":"EditCompany_line__2BTqz","step-card":"EditCompany_step-card__1YAG-"};